export default {
    data() {
        return {

        };
    },

    methods: {},

    computed: {
        ERPConfig() {
            return this.$store.getters['ERPConfig'];
        },
        ERPBaseAssembly() {
            return this.ERPConfig.ERPBaseAssembly;
        },
        ERPFriendlyName() {
            return this.ERPConfig.ERPFriendlyName;
        },
        CustomerReadonly() {
            return this.ERPConfig.CustomerReadonly === false ? false : true;
        },
        CustomerAddressReadonly() {
            return this.ERPConfig.CustomerAddressReadonly === false ? false : true;
        },
        CustomerAddressLocalReadonly() {
            return this.ERPConfig.CustomerAddressLocalReadonly === false ? false : true;
        },
        CustomerAddressCanCreateInErp() {
            return this.ERPConfig.CustomerAddressCanCreateInErp === true ? true : false;
        },
        CustomerAddressCanCreateLocal() {
            return this.ERPConfig.CustomerAddressCanCreateLocal === true ? true : false;
        },
        CustomerPersonsReadonly() {
            return this.ERPConfig.CustomerPersonsReadonly === false ? false : true;
        },
        SupplierReadonly() {
            return this.ERPConfig.SupplierReadonly === false ? false : true;
        },
        EmploymentReadonly() {
            return this.ERPConfig.EmploymentReadonly === false ? false : true;
        },
        //Custom Integration appsetting that makes prices 0 with the expectaion that the ERP will set the price in post.
        UseOrderGeneratedArticlePrice() {
            return this.ERPConfig.UseOrderGeneratedArticlePrice;
        },
    },
}